export default __webpack_public_path__ + "static/media/logoFD.a69a6b9d.svg";